"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitiesBase = void 0;
class EntitiesBase {
    constructor() {
        this.events = {};
    }
    emit(eventName, obj) {
        if (this.events[eventName]) {
            this.events[eventName].forEach((listener) => { listener(obj); });
        }
    }
    off(eventName, listener) {
        if (this.events[eventName]) {
            return;
        }
        const l = this.events[eventName].length;
        for (let i = 0; i < l; i++) {
            if (this.events[eventName][i] === listener) {
                this.events[eventName].splice(i, 1);
                break;
            }
        }
    }
    on(eventName, listener) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        else {
            const l = this.events[eventName].length;
            for (let i = 0; i < l; i++) {
                if (this.events[eventName][i] === listener) {
                    return;
                }
            }
        }
        this.events[eventName].push(listener);
    }
}
exports.EntitiesBase = EntitiesBase;
//# sourceMappingURL=EntitiesBase.js.map